import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { format, parseISO } from 'date-fns';
import * as am5percent from "@amcharts/amcharts5/percent";
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import animation from '../../../../images/jm-animation.gif';

function Top5Sectors(props) {
    const [data, setData] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [chartdata, setchartdata] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getSchemeCodeIn = props.getSchemeCode;

    useEffect(() => {
        setloadingshow(true);
        GetPostMethodData(BaseURL + "GetSectorAllocation", {
            IVSchemeCode: getSchemeCodeIn,
        }).then((data) => {
            setloadingshow(false);
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                setchartdata(DecryptAESdata(data.data))
                setloadingshow(false);
                console.log(DecryptAESdata(data.data))

            }
        });
    }, [BaseURL]);

    useLayoutEffect(() => {
        am5.addLicense("AM5C420959785");
        var root = am5.Root.new("SectorChartDiv");
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        var chart = root.container.children.push(am5percent.PieChart.new(root, {
            layout: root.verticalLayout,
        }));

        var series = chart.series.push(am5percent.PieSeries.new(root, {
            valueField: "value",
            categoryField: "category",
            legendLabelText: "{category}",

        }));

        // ❌ Disable tooltip
        series.slices.template.set("tooltipText", "");

        // ❌ Disable all interactions (hover, click)
        series.slices.template.setAll({
            interactive: false,
        });

        // ❌ Remove hover state effects (important)
        series.slices.template.states.create("hover", {});

        series.get("colors").set("colors", [
            am5.color("#3bafcb"),
            am5.color("#25d8ff"),
            am5.color("#ace3df"),
            am5.color("#063b73"),
            am5.color("#869d9f"),
        ]);

        function generateChartData() {
            let chartData = [];
            if (chartdata != null) {
                for (var i = 0; i < chartdata.length; i++) {
                    if (chartdata[i].Percentage != null) {
                        chartData.push({
                            category: chartdata[i].Sector,
                            value: (chartdata[i].Percentage).toFixed(2)
                        });
                    }
                }
                return chartData;
            }
        }
        let data = generateChartData();

        series.data.setAll(data);

        // series.ticks.template.set("visible", true);
        // series.labels.template.set("forceHidden", true);

        series.labels.template.setAll({
            maxWidth: 100,
            oversizedBehavior: "wrap",
            fontSize: 9,
            text: "{value}%"
        });

        var legend = chart.children.push(am5.Legend.new(root, {
            dx: 80,
            clickTarget: 'none',
            centerX: am5.percent(75),
            x: am5.percent(50),
            layout: root.verticalLayout
            // layout: am5.GridLayout.new(root, {
            //     maxColumns: 2,
            //     fixedWidthGrid: true
            // })
        }));

        legend.itemContainers.template.setAll({
            interactive: false,
            focusable: false,
            });

         legend.labels.template.setAll({
                fontSize: 11,
                focusable: false,
              });
        legend.valueLabels.template.set("forceHidden", true);
        legend.data.setAll(series.dataItems);


        //On hover Slice 
        legend.itemContainers.template.events.on("pointerover", function (e) {
            const dataItem = e.target.dataItem?.dataContext;

            if (dataItem) {
                dataItem.get("slice")?.hover();
            }
            });

            legend.itemContainers.template.events.on("pointerout", function (e) {
            const dataItem = e.target.dataItem?.dataContext;

            if (dataItem) {
                dataItem.get("slice")?.unhover();
            }
            });

        series.appear(1000, 100);
        return () => {
            root.dispose();
        };
    }, [chartdata]);


    

    return (
        <>


            <div className="gradiant-head-box">
                <div className="gradiant-head-container">
                    <h3 className="gradiant-head">Top 5 Sectors</h3>
                </div>
                <div className="gradiant-content">
                    <div className="padding-box-inner paddingChart" style={{position : "relative"}}>
                        {/* {(data.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} */}
                        {/* {loadingshow ? <div className="textcentervertex">
                            <img src={animation} alt="Loading" />
                            <div className="model_popup">Please Wait...</div>
                        </div> : ""
                        } */}
                        {loadingshow ? (
                            <div className="textcentervertex HomeLoader" role="status" aria-live="polite" aria-busy="true">
                                <img src={animation} alt="" aria-hidden="true" />
                                <div className="model_popup">Please Wait...</div>
                            </div>
                        ) : (
                            <div>
                                <div id="SectorChartDiv" style={{ width: "100%", height: "390px" }}></div>

                                {data.length < 2 && (
                                    <div
                                    style={{
                                        textAlign : "center",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        position : "absolute",
                                        top : "45%",
                                        // left : "3%"
                                    }}
                                    
                                    >Since this is a new scheme, Top Sector data is not yet available</div>
                                )
                                }


                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
        // <>
        //     <div className="gradiant-head-box">
        //         <div className="gradiant-head-container">
        //             <h3 className="gradiant-head">Top 5 Sectors</h3>
        //         </div>
        //         <div className="gradiant-content">
        //             <div className="padding-box-inner paddingChart">
        //                 {loadingshow ? (
        //                     <div className="textcentervertex HomeLoader">
        //                         <img src={animation} alt="Loading" />
        //                         <div className="model_popup">Please Wait...</div>
        //                     </div>
        //                 ) : data && data.Sector === "Other Sector's" ? (
        //                     <h6 className="errorMsg">Data not found !!!</h6>
        //                 ) : (
        //                     <div id="SectorChartDiv" style={{ width: "100%", height: "390px" }}></div>
        //                 )}
        //             </div>
        //         </div>
        //     </div>
        // </>


    )
}

export default Top5Sectors